var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',_vm._g(_vm._b({staticClass:"submit-button"},'base-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v("\n    "+_vm._s(_vm.$t('generic.save'))+"\n  ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }